import fieldAgentConstants from '../field/util/constants'
// BOOT_VISION_CONSTANTS is injected by the backend.
// This way we don't need to keep these constants in sync with the backend manually.

const constants = window.BOOT_VISION_CONSTANTS

export const LICENSE_CASE = 'L'
export const VIN_CASE = 'V'
export const PASSPORT = 'Passport'
export const BOOTBOX_STATUS = 'F'
// boot types
export const BOOT_TYPE_BOOTLOCK = 'B'
export const BOOT_TYPE_PAYLOCK = 'P'
export const BOOT_TYPE_HARDCODED = 'H'

function invertDictionary (m) {
  const r = {}
  for (const k in m) {
    r[m[k]] = k
  }
  return r
}

if (constants.caseStatus) {
  constants.caseStatusCodes = invertDictionary(constants.caseStatus)
}

if (constants.businessRules) {
  const rulesAsDictionary = {}

  constants.businessRules.forEach(rule => {
    rulesAsDictionary[rule] = rule
  })

  constants.businessRules = rulesAsDictionary
}

if (constants.caseLogEvents) {
  constants.caseLogEventCodes = invertDictionary(constants.caseLogEvents)
}

if (constants.releaseMethods) {
  constants.releaseMethodCodes = invertDictionary(constants.releaseMethods)
}

if (constants.wheelClampStatus) {
  constants.wheelClampStatusCodes = invertDictionary(constants.wheelClampStatus)
}

if (constants.wheelClampConditions) {
  constants.wheelClampConditionCodes = invertDictionary(constants.wheelClampConditions)
}

const orderedCountries = (usaFirst = true) => {
  // sorts countries alphabetically
  const orderedCountries = Object.entries(constants.countryCodes).sort((a, b) => {
    const aName = a[1]
    const bName = b[1]

    return aName.localeCompare(bName)
  })

  if (usaFirst) {
    // put USA first
    const index = orderedCountries.findIndex((a) => a[0] === 'USA')
    orderedCountries.unshift(orderedCountries.splice(index, 1)[0])
  }

  return orderedCountries
}

const orderedStates = (defaultStates) => {
  const states = Object.entries(constants.states)
  defaultStates.slice().reverse().forEach((defaultState) => {
    const index = states.findIndex((a) => a[0] === defaultState)
    states.unshift(states.splice(index, 1)[0])
  })

  return states
}

const listDisplaysBootData = (uid) => {
  return (uid === fieldAgentConstants.PENDING_LIST_UID || uid === fieldAgentConstants.ACCEPTED_LIST_UID || uid === fieldAgentConstants.DONE_LIST_UID || uid === fieldAgentConstants.DONE_BOOT_LIST_UID)
}

export default constants
export { orderedCountries, orderedStates, listDisplaysBootData }
